import React, { Component } from 'react';
import {
    Input,
    Label,
    FormGroup,
    InputGroupAddon,
    InputGroupText,
    InputGroup,
} from "reactstrap";

import Select from 'react-select';

class TSSelect extends Component {
    
    constructor(props) {
        super(props);

        this.state = {
            name: props.name,
            placeholder: props.placeholder,
            parent: (props.parent != null) ? props.parent : null,
            isDefault: (props.isDefault != null) ? props.isDefault : false,
            value: (props.value != null) ? props.value : '',
            marginBottom: (props.marginBottom != null) ? props.marginBottom : '12px',
            zIndex: (props.zIndex != null) ? props.zIndex : 'null',
            //value: { value: (props.value != null) ? props.value : '' },
            //value: { label: 'สงขลา', value: '70' },
            //value: '',
            url: props.url,
            fixData: props.fixData,
            isSearch: (props.isSearch != null) ? props.isSearch : true,
            options: (props.options != null) ? props.options : [],
            isFocus: false,
            isNew: (props.isNew != null) ? props.isNew :false,
            selectedOption: null,
            defaultValue: { label: null, value: null },
            invalid: (props.invalid !== "undefined") ? props.invalid : null,
            require: props.require,
            height: (props.height != null) ? props.height : '50px',
            fontSize: (props.fontSize != null) ? props.fontSize : '1.2em'
        };
        //this.handleChange = this.handleChange.bind(this);
    }

    componentDidUpdate(prevProps) {
        
        if (this.props.invalid !== prevProps.invalid) {
            if (this.state.require) {
                this.setState({ invalid: this.props.invalid });
                this.setState({ isFocus: this.props.invalid });
            }
        }
        

        if (this.props.options !== prevProps.options) {
            this.setState({ options: this.props.options });

            const val = this.props.options.find(e => e.value == this.props.value)
            if (val !== undefined)
                this.setState({ defaultValue: val });
            else
                this.setState({ defaultValue: { label: null, value: null } });

        }
        else if (this.props.value !== prevProps.value || this.props.parent !== prevProps.parent) {

            if (this.state.url != null) {
                const requestOptions = {
                    method: 'GET',
                    headers: {
                        'Content-Type': 'application/json-patch+json',
                    }
                };

                var url = (this.props.parent != null) ? this.state.url + this.props.parent : this.state.url;
                //console.log(url)

                fetch(url, requestOptions)
                    .then(response => response.json())
                    .then(
                        (result) => {

                            this.setState({ options: result.data });

                            if (this.props.parent !== undefined && this.props.parent == null) {
                                this.setState({ defaultValue: { label: null, value: null } });
                            }
                            else {
                                const val = result.data.find(e => e.value == this.props.value)
                                if (val !== undefined)
                                    this.setState({ defaultValue: val });
                                else
                                    this.setState({ defaultValue: { label: null, value: null } });
                            }

                            //

                            //if (prevProps.parent != null && this.state.parent == '')
                            //    this.setState({ defaultValue: { label: null, value: null } });


                        },
                        (error) => {
                            //alert(error);
                        }
                    )
            }
            else {
                const val = this.state.options.find(e => e.value == this.props.value)
                if (val !== undefined)
                    this.setState({ defaultValue: val });
                else
                    this.setState({ defaultValue: { label: null, value: null } });
            }

            /*
            const val = this.state.options.find(e => e.value == this.props.value)
            this.setState({ defaultValue: val });
            console.log('-------------------------------');
            console.log(this.state.placeholder);
            console.log(this.props);
            console.log(this.state.options);
            console.log(val);
            */
        }
        else if (this.props.parent2 != prevProps.parent2) {
            this.setState({ options: null });
            this.setState({ defaultValue: { label: null, value: null } });
        }

       
    }

    componentDidMount() {

        if (this.state.url != null && this.state.isNew) {
            const requestOptions = {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json-patch+json',
                }
            };

            var url = (this.props.parent != null) ? this.state.url + this.props.parent : this.state.url;

            fetch(url, requestOptions)
                .then(response => response.json())
                .then(
                    (result) => {

                        this.setState({ options: result.data });

                        if (this.props.parent !== undefined && this.props.parent == null) {
                            this.setState({ defaultValue: { label: null, value: null } });
                        }
                        else {
                            const val = result.data.find(e => e.value == this.props.value)
                            if (val !== undefined)
                                this.setState({ defaultValue: val });
                            else
                                this.setState({ defaultValue: { label: null, value: null } });
                        }

                    },
                    (error) => {
                        //alert(error);
                    }
                )
        }
        else {
            const val = this.state.options.find(e => e.value == this.props.value)
            if (val !== undefined)
                this.setState({ defaultValue: val });
            else
                this.setState({ defaultValue: { label: null, value: null } });
        }



        if (this.state.fixData != null) {
            const options2 = [
            ];

            if (this.state.fixData == "day")
            {
                for (let i = 1; i <= 31; i++) {
                    options2.push({ "value": i, "label": i });
                }
                this.setState({ options: options2 });
            }
            else if (this.state.fixData == "month") {

                var moment = require('moment');
                require('moment/locale/th');
                var y = moment().format('YYYY');

                for (let i = 1; i <= 12; i++) {

                    var mTxt = y + "-" + i + "-01";

                    var m = moment(mTxt, "YYYY-M-DD").format('MMMM');

                    moment.locale('en')
                    var me = moment(mTxt, "YYYY-M-DD").format('MMMM');
                    moment.locale('th')
                    options2.push({ "value": i, "label": m+ ' / '+me });
                }
                this.setState({ options: options2 });
            }
            else if (this.state.fixData == "year") {
                var moment = require('moment');
                require('moment/locale/th');
                var y = parseInt(moment().format('YYYY'));

                for (let i = y; i >= (y - 100); i--) {
                    options2.push({ "value": i, "label": (i + 543) + ' / ' + i });
                }
                this.setState({ options: options2 });
            }
            else if (this.state.fixData == "gender") {

                options2.push({ "value": -1, "label": "ชาย" });
                options2.push({ "value": -2, "label": "หญิง" });

                this.setState({ options: options2 });
            }
            else if (this.state.fixData == "gender2") {

                options2.push({ "value": 1, "label": "ชาย" });
                options2.push({ "value": 2, "label": "หญิง" });

                this.setState({ options: options2 });
            }
        }
        


 
    }

    /*
    handleChange = selectedOption => {
        this.setState({ selectedOption });

        if (this.props.onChange)
            this.props.onChange(selectedOption);
    };
    */
    
    handleChange = selectedOption => {
        var val = (selectedOption != null ) ? selectedOption.value : null;

        if (this.state.isDefault)
            val = (selectedOption != null) ? selectedOption.target.value : null;


        this.setState({ value: val });

        if (this.state.require) {
            this.setState({ invalid: (!!!selectedOption) });
            this.setState({ isFocus: (!!!selectedOption) });
        }

        if (this.props.onSelectedChange !== undefined) {
            this.props.onSelectedChange(selectedOption);
        }

        if (this.props.onChange)
            this.props.onChange(val);
    };
    
    render() {

        const customStyles = {
            container: (base) => ({ ...base, zIndex: this.state.zIndex }),
            control: (base) => ({ ...base, padding: this.state.marginBottom+' 5px', marginBottom: '10px', border: (this.state.invalid ? "red solid 1px" : "") }),
            menu: (base) => ({ ...base, textAlign: 'left', fontSize: '1.2em' }),
            singleValue: (base) => ({ ...base, fontSize: '1.2em' }),
        }

        return (
           
            (!this.state.isDefault) ? 
            <div>
                <Label>{this.state.placeholder}</Label>
                <Select
                    styles={customStyles}   
                    value={this.state.defaultValue}
                    onChange={this.handleChange}
                    options={this.state.options}
                    isSearchable={this.state.isSearch}
                    isClearable={true}
                    placeholder={this.state.placeholder}
               />
            </div>

            :

            <select
                className="form-control"
                style={{
                    borderRadius: '0',
                    marginBottom: '10px',
                    //height: '50px',
                    height: this.state.height,
                    paddingLeft:'20px',
                    //fontSize: '1.2em',
                    fontSize: this.state.fontSize,
                    color: '#555555',
                    backgroundColor: '#ffffff',
                    border: '1px solid #cccccc',
                }}
                value={this.selectedOption}
                onChange={this.handleChange}
                >
                    <option>{this.state.placeholder}</option>
                    {this.state.options.map(key => <option key={key.value} value={key.value}>{key.label}</option>) }
            </select>

           

        );
    }
}
export default TSSelect;